import React from 'react';
import colors from '../theme/colors';
import ReactSelect, { formatDotLabel, formatDotStyles } from './ReactSelect';

export type GenericStatus = (typeof statusOptions)[number]['value'];

const statusOptions = [
  {
    value: 'ACTIVE',
    label: 'Active',
    color: colors.statusSuccess,
  },
  {
    value: 'INACTIVE',
    label: 'Inactive',
    color: colors.statusError,
  },
] as const;

export const GenericStatusPicker = ({
  value,
  isClearable,
  onChange,
}: {
  value?: GenericStatus;
  isClearable?: boolean;
  onChange: (value?: GenericStatus) => void;
}) => (
  <ReactSelect
    placeholder="status"
    isClearable={isClearable}
    value={statusOptions.find((option) => value === option.value)}
    styles={{
      menu: (base) => ({
        ...base,
        minWidth: '120px',
      }),
      multiValue: formatDotStyles,
    }}
    formatOptionLabel={formatDotLabel}
    onChange={(value) => {
      onChange(value?.value ?? undefined);
    }}
    options={statusOptions}
  />
);
